import TopBar from './components/TopBar';
import Header from './components/Header';
import Hero from './components/Hero';
import FeedSection from './components/FeedSection';
import ArchiveSection from './components/ArchiveSection';
import TimelineSection from './components/TimelineSection';
import RankSection from './components/RankSection';
import LeadSection from './components/LeadSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-950">
      <TopBar />
      <Header />
      <main>
        <Hero />
        <FeedSection />
        <ArchiveSection />
        <TimelineSection />
        <RankSection />
        <LeadSection />
      </main>
      <Footer />
    </div>
  );
}